import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScaleLoader = _resolveComponent("ScaleLoader")!
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ScaleLoader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.displayChart && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LineChart, _mergeProps({
            height: _ctx.windowHeight - 215,
            "chart-id": "chart"
          }, _ctx.lineChartProps), null, 16, ["height"]),
          _createElementVNode("button", {
            class: "btn btn-custom",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetZoom('chart')))
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-custom",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exportToImg('image/png', 'chart', _ctx.imei)))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "bi bi-filetype-png" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-custom",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportToImg('image/jpeg', 'chart', _ctx.imei)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "bi bi-filetype-jpg" }, null, -1)
          ]))]),
          _createElementVNode("button", {
            class: "btn btn-custom",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportCsv()))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
          ]))])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}